import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import * as notify from "../shared/notify";
import classnames from "classnames";

import PaginatedTable from "../components/table/index";

import { getProducts, getStatusList, getProductExportUrl } from "./lib/stagingData";
import { buildSearchColumns } from "./lib/constants";
import { getCSV } from "shared/data";

const SearchUpcIndex = () => {
    const [workflowStatus, setWorkflowStatus] = useState(null);
    const [exportUrl, setExportUrl] = useState("/pre-shipment-packages/export?pagesize=20&pagenumber=1");
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            const workflowStatuses = await getStatusList();

            if (!workflowStatuses || !workflowStatuses.values) {
                return;
            }

            const newStatusListMap = workflowStatuses.values.reduce((obj, s) => {
                obj[s.value] = s.text;

                return obj;
            }, {});

            setWorkflowStatus({
                map: newStatusListMap,
                list: workflowStatuses.values,
            });
        };
        fetchData();
    }, []);

    const interceptGetProducts = (pageNumber, pageSize, sort, filter) => {
        setExportUrl(getProductExportUrl(pageNumber, pageSize, sort, filter));

        return getProducts(pageNumber, pageSize, sort, filter);
    };

    const updateTotalRecords = (data) => {
        setTotalRecords(data.totalRecords);
    };

    const linkClick = async (e) => {
        if (totalRecords <= 0) {
            e.preventDefault();
        }

        const file = await getCSV(exportUrl);

        if (!file) {
            return notify.error("You do not have permission to perform this action.");
        }

        return file;
    };

    return (
        <div>
            <div className="button-group">
                <h1>Search UPC</h1>
                <button className={classnames("button", { "-disabled": totalRecords <= 0 })} title="Export" onClick={linkClick}>
                    <FontAwesomeIcon icon={faFileExport} />
                </button>
            </div>
            {workflowStatus && (
                <PaginatedTable
                    getData={interceptGetProducts}
                    getDataCallback={updateTotalRecords}
                    columns={buildSearchColumns(workflowStatus)}
                    minRows="10"
                />
            )}
        </div>
    );
};

export default SearchUpcIndex;
